export default __webpack_public_path__ + "static/BasierCircle-MediumItalic-73b739d85077bbd2d5490793a18d66e9.woff2";